import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  imports: [CommonModule, MatIconModule],
  selector: 'hlp-tag',
  template: `
    @let tagInnerClass = 'tag--' + this.innerClass();

    <!--     eslint-disable-next-line @angular-eslint/template/no-inline-styles-->
    <span
      class="tag"
      [ngClass]="tagInnerClass + ' ' + customClasses()"
      [ngStyle]="{ 'background-color': backgroundColor() }"
    >
      @let iconVal = this.icon();

      @if (iconVal) {
        <mat-icon class="tw:mr-0! tw:size-4!" [ngClass]="tagInnerClass + '__icon'" [svgIcon]="iconVal" />
      }

      @if (!!label()) {
        <span>{{ label() }}</span>
      }

      <ng-content></ng-content>

      @if (removable()) {
        <button class="tag__btn" (click)="removeTag.emit()" type="button">
          <mat-icon class="tag__btn__icon" svgIcon="cross"></mat-icon>
        </button>
      }
    </span>
  `,
  styleUrls: ['./tag.component.scss', 'status-tag.scss'],
})
export class TagComponent {
  customClasses = input<string>();
  innerClass = input<string>('');
  label = input<string>();
  removable = input<boolean>(false);
  icon = input<string>();
  backgroundColor = input<string>();

  removeTag = output<void>();
}
